namespace TabAurous.Common {
    export interface AVGRateResponse extends Serenity.ServiceResponse {
        Rate?: number;
    }
}
